export default __webpack_public_path__ + "static/media/Add ConsumerApp_Blue.8115eca1.svg";